import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ menu = [] }) {
  return (
    <div className="flex min-h-screen flex-col bg-[#F8F5F0] font-sans antialiased">
      <Header menu={menu} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
